import OverallDevelopmentResult from './model';

export default OverallDevelopmentResult;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/result/index.js